import clsx from "clsx";
import React, { FC } from "react";

import { useHeaderMenu } from "../../../../hooks/use-header-menu";
import { SearchForm } from "../../common/search-form";
import { HeaderMenuItemCloseButton } from "../header-menu-item-close-button";

export interface SearchSpecialItemProps {
  className?: string;
}

export const SearchSpecialItem: FC<SearchSpecialItemProps> = ({ className }) => {
  const { labels } = useHeaderMenu();
  return (
    <div className={clsx("flex flex-col gap-4 w-full relative", className)}>
      <div className="flex items-center justify-between">
        <h3 className="text-2xl text-primary pt-5">{labels["header-menu-search-title"]}</h3>{" "}
        <HeaderMenuItemCloseButton />
      </div>
      <SearchForm />
    </div>
  );
};
